import { GET_ALL_USER_SUCCESS, GET_ALL_USER_FAIL, GET_ALL_USER } from "./actionTypes"

const INITIAL_STATE = {
  users: [],
  error: {},
  loader: false,
}

const GetUser = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_ALL_USER:
      return {
        ...state,
        loader: true,
      }
    case GET_ALL_USER_SUCCESS:
      return {
        ...state,
        users: action.payload,
        loader:false,
      }

    case GET_ALL_USER_FAIL:
      return {
        ...state,
        error: action.payload,
        loader:false,
      }
    default:
      return state
  }
}

export default GetUser
